/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiVersion } from './ApiVersion';
import type { VulnerabilityGroupItem } from './VulnerabilityGroupItem';
/**
 * A CVE grouped across one or more images, as returned by fleet-scoped and organization-wide vulnerability list endpoints. Each finding represents one image in which the CVE was detected.
 *
 */
export type VulnerabilityGroup = {
  apiVersion: ApiVersion;
  /**
   * Kind is a string value representing the REST resource. Always VulnerabilityGroup.
   */
  kind: string;
  /**
   * CVE identifier (e.g. CVE-2024-1234).
   */
  cveId: string;
  /**
   * Worst severity across all findings in this group.
   */
  severity: VulnerabilityGroup.severity;
  /**
   * Highest CVSS base score across all findings.
   */
  maxCvssScore?: number;
  /**
   * Latest advisory publish time across all findings.
   */
  maxPublishedAt?: string;
  /**
   * Total distinct devices affected by this CVE within scope.
   */
  affectedDevices?: number;
  /**
   * Per-digest findings for this CVE within the query scope.
   */
  findings: Array<VulnerabilityGroupItem>;
};
export namespace VulnerabilityGroup {
  /**
   * Worst severity across all findings in this group.
   */
  export enum severity {
    CRITICAL = 'Critical',
    HIGH = 'High',
    MEDIUM = 'Medium',
    LOW = 'Low',
    NONE = 'None',
    UNKNOWN = 'Unknown',
  }
}

